import internalStateService from "../app/InternalStateService";
import translationService from "../app/TranslationService";
import urlUtils from "@tinqin/tinqin-utils/src/url";
import { WIDGET_DATA_SUCCESS } from "./Widget";
import { createFormData, createJSONData } from "../utils/dataUtils";
import { loadMissingComponents } from "./Loader";
import { WEBUILogs } from "@tinqin/tinqin-utils/src/logging";

export const FLOW_REQUEST = "FLOW_REQUEST";
export const FLOW_SUCCESS = "FLOW_SUCCESS";

export const SET_FLOW_CONTEXT = "SET_FLOW_CONTEXT";
export const SET_ACTIVE_FLOW = "SET_ACTIVE_FLOW";
//export const SET_ACTIVE_FLOW_TARGET = "SET_ACTIVE_FLOW_TARGET";
export const RESET_ACTIVE_FLOW = "RESET_ACTIVE_FLOW";
//export const RESET_ACTIVE_FLOW_TARGET = "RESET_ACTIVE_FLOW_TARGET";

export const END_FLOW = "END_FLOW";

export const STEP_REQUEST = "STEP_REQUEST";
export const STEP_SUCCESS = "STEP_SUCCESS";

export const STEP_DATA_REQUEST = "STEP_DATA_REQUEST";
export const STEP_DATA_SUCCESS = "STEP_DATA_SUCCESS";

export const STEP_POST_REQUEST = "STEP_POST_REQUEST";
export const STEP_POST_SUCCESS = "STEP_POST_SUCCESS";

export const RESUME_STEP_REQUEST = "RESUME_STEP_REQUEST";
export const RESUME_STEP_SUCCESS = "RESUME_STEP_SUCCESS";
export const RESUME_STEP_FAILURE = "RESUME_STEP_FAILURE";

export const SET_STEP_ATTRIBUTE = "SET_STEP_ATTRIBUTE";

export const REQUEST_FLOW_REQUEST = "REQUEST_FLOW_REQUEST";
export const REQUEST_FLOW_SUCCESS = "REQUEST_FLOW_SUCCESS";

export const CANCEL_FLOW_REQUEST = "CANCEL_FLOW_REQUEST";
export const CANCEL_FLOW_SUCCESS = "CANCEL_FLOW_SUCCESS";

export const COMPLETE_FLOW_REQUEST = "COMPLETE_FLOW_REQUEST";
export const COMPLETE_FLOW_SUCCESS = "COMPLETE_FLOW_SUCCESS";

export const SET_VISIBLE_STEP = "SET_VISIBLE_STEP";

function fetchFlow(endpoint, widget) {
    WEBUILogs.log("Fetch flow.");
    return async (dispatch) => {
        let actionResult;
        try {
            await dispatch({
                type: FLOW_REQUEST
            });
            dispatch(
                setFlowUiState(widget, {
                    flowLoading: true
                })
            );
            actionResult = await dispatch(
                internalStateService.getActionByName("request.request")(
                    {
                        endpoint: endpoint
                    },
                    {
                        widgetId: widget
                    }
                )
            );
            dispatch({
                type: FLOW_SUCCESS,
                payload: Object.assign({}, actionResult, {
                    widget: widget
                })
            });
            dispatch(
                setFlowUiState(widget, {
                    flowLoading: false,
                    visibleStep: false
                })
            );
            dispatch((dispatch, getState) => {
                var steps = getState().getIn(["data", widget, "entities"]);
                var isFinished = false;
                if (
                    steps &&
                    !steps.find((item) => {
                        return item.getIn(["properties", "status"]) === "pending";
                    })
                ) {
                    isFinished = true;
                }
                if (isFinished) {
                    var actions = getState().getIn(["data", widget, "actions"]);
                    var completeFlowAction = actions.find((action) => {
                        return action.get("actionType") === "completeFlow";
                    });
                    var href = completeFlowAction ? completeFlowAction.get("href") : null;
                    if (href) {
                        return dispatch(
                            completeFlow.apply(undefined, [
                                href,
                                widget,
                                { action: "completeFlow" }
                            ])
                        );
                    } else {
                        return dispatch(
                            internalStateService.getActionByName("flow.endFlowAndSwitchDashboard")(
                                widget
                            )
                        );
                    }
                }
            });
        } catch (error) {
            actionResult = Promise.reject(error);
            if (error.name === "ApiError") {
                dispatch(
                    internalStateService.getActionByName("messages.triggerMessages")([
                        {
                            type: "error",
                            messages: [translationService.translate("flowFailure")]
                        }
                    ])
                );
            }
        } finally {
            dispatch(
                setFlowUiState(widget, {
                    flowLoading: false
                })
            );
        }
        return actionResult;
    };
}

export function updateFlowSirenAction(action, widgetId) {
    return reloadFlow(widgetId);
}

export function reloadFlow(widgetId) {
    WEBUILogs.log("reloadFlow");
    return (dispatch, getState) => {
        var flowActions = getState().getIn(["data", widgetId, "actions"]);
        var loadFlowAction = flowActions.find((action) => {
            return action.get("actionType") === "getAvailableSteps";
        });
        var loadFlowUrl = loadFlowAction.get("href");

        return dispatch(fetchFlow(loadFlowUrl, widgetId));
    };
}

export function loadFlow(endpoint, widget, requiredFields = []) {
    WEBUILogs.log("loadFlow.");
    return (dispatch, getState) => {
        if (endpoint) {
            return dispatch(fetchFlow(endpoint, widget));
        }
        return null;
    };
}

function fetchStep(configEndpoint, dataEndpoint, step, widgetId, component) {
    WEBUILogs.log("fetchStep.");
    return async (dispatch) => {
        let actionResult;
        try {
            await dispatch({
                type: STEP_REQUEST
            });
            dispatch(
                internalStateService.getActionByName("component.setUiState")(widgetId, step, {
                    actionInProgress: "fetchStep",
                    isLoading: true
                })
            );
            actionResult = await dispatch(
                internalStateService.getActionByName("request.request")(
                    {
                        method: "GET",
                        endpoint: configEndpoint
                    },
                    {
                        widgetId: widgetId
                    }
                )
            );
            actionResult = await loadMissingComponents({ config: actionResult, widgetId });
            dispatch({
                type: STEP_SUCCESS,
                payload: Object.assign({}, actionResult, {
                    widgetId: widgetId,
                    step: step,
                    componentId: component
                })
            });
        } catch (error) {
            actionResult = Promise.reject(error);
            if (error.name === "ApiError") {
                dispatch(
                    internalStateService.getActionByName("messages.triggerMessages")([
                        {
                            type: "error",
                            messages: [translationService.translate("stepConfigFailure")]
                        }
                    ])
                );
            }
        } finally {
            dispatch(
                internalStateService.getActionByName("component.setUiState")(widgetId, step, {
                    actionInProgress: false,
                    isLoading: false
                })
            );
        }
        return actionResult;
    };
}

export function loadStep(
    endpoint,
    dataEndpoint,
    stepId,
    widgetId,
    componentId,
    requiredFields = []
) {
    const revalidateEntities = internalStateService.getActionByName(
        "validations.revalidateEntities"
    );
    const triggerActionsOnLoadData = internalStateService.getActionByName(
        "widget.triggerActionsOnLoadData"
    );
    WEBUILogs.log("loadStep");
    return async (dispatch, getState) => {
        if (internalStateService.getGlobalProperties("screenSizeQueryParameter")) {
            //adding endpoint for steps
            let size = getState().getIn(["windowSize", "size"]);
            endpoint += "?screenSize=" + size;
            dataEndpoint += "?screenSize=" + size;
        }

        await dispatch(fetchStep(endpoint, dataEndpoint, stepId, widgetId, componentId));

        let result = await dispatch(fetchStepData(dataEndpoint, stepId, widgetId));

        dispatch(triggerActionsOnLoadData(widgetId, stepId));

        let rootElement = getState().getIn(["data", widgetId, "class", 0]);
        dispatch(revalidateEntities(widgetId, { entityPath: rootElement + "." + stepId }));

        return result;
    };
}

function fetchStepData(endpoint, step, widgetId) {
    var { FLOW_ROOT, STEP_ROOT } = internalStateService.getWebConfig();

    WEBUILogs.log("fetchStepData.");
    var href = endpoint ? endpoint : FLOW_ROOT + `/${widgetId}` + STEP_ROOT + `/${step}`;
    return async (dispatch) => {
        let actionResult;
        try {
            await dispatch({
                type: STEP_DATA_REQUEST
            });
            dispatch(
                internalStateService.getActionByName("component.setUiState")(widgetId, step, {
                    actionInProgress: "fetchStepData",
                    isLoading: true
                })
            );
            actionResult = await dispatch(
                internalStateService.getActionByName("request.request")(
                    {
                        method: "GET",
                        endpoint: href
                    },
                    {
                        widgetId: widgetId
                    }
                )
            );
            dispatch({
                type: STEP_DATA_SUCCESS,
                payload: Object.assign({}, actionResult, {
                    widgetId: widgetId,
                    step: step
                })
            });
        } catch (error) {
            actionResult = Promise.reject(error);
            if (error.name === "ApiError") {
                dispatch(
                    internalStateService.getActionByName("messages.triggerMessages")([
                        {
                            type: "error",
                            messages: [translationService.translate("stepDataFailure")]
                        }
                    ])
                );
            }
        } finally {
            dispatch(
                internalStateService.getActionByName("component.setUiState")(widgetId, step, {
                    actionInProgress: false,
                    isLoading: false
                })
            );
        }
        return actionResult;
    };
}

export function loadStepData(endpoint, step, widgetId, requiredFields = []) {
    WEBUILogs.log("loadStepData.");
    return (dispatch, getState) => {
        if (endpoint) {
            return dispatch(fetchStepData(endpoint, step, widgetId));
        } else {
            return Promise.reject();
        }
    };
}

function requestSubmitStep(endpoint, method, widgetId, stepId, payload) {
    const revalidateEntities = internalStateService.getActionByName(
        "validations.revalidateEntities"
    );
    WEBUILogs.log("requestSubmitStep");
    return async (dispatch, getState) => {
        let actionResult;
        try {
            await dispatch({
                type: STEP_POST_REQUEST
            });
            dispatch(internalStateService.getActionByName("loading.triggerGlobalLoading")());
            dispatch(
                internalStateService.getActionByName("component.setUiState")(widgetId, stepId, {
                    actionInProgress: "requestSubmitStep",
                    isLoading: true
                })
            );
            actionResult = await dispatch(
                internalStateService.getActionByName("request.request")(
                    {
                        endpoint: endpoint,
                        method: method,
                        headers: {
                            /*; boundary=${typeof payload.getBoundary === 'function' ?
             payload.getBoundary() : ""}`*/
                            "Content-Type": `multipart/form-data`
                        },
                        payload: payload
                    },
                    {
                        widgetId: widgetId
                    }
                )
            );
            if (!actionResult) {
                actionResult = { isEmpty: true };
            }
            await dispatch({
                type: STEP_POST_SUCCESS,
                payload: Object.assign({}, payload, actionResult, {
                    widgetId: widgetId,
                    step: stepId
                })
            });
            let rootElement = getState().getIn(["data", widgetId, "class", 0]);
            dispatch(revalidateEntities(widgetId, { entityPath: rootElement + "." + stepId }));
        } catch (error) {
            actionResult = Promise.reject(error);
            if (error.name === "ApiError") {
                dispatch(
                    internalStateService.getActionByName("messages.triggerMessages")([
                        {
                            type: "error",
                            messages: [translationService.translate("stepPostFailure")]
                        }
                    ])
                );
            }
        } finally {
            dispatch(internalStateService.getActionByName("loading.dismissGlobalLoading")());
            dispatch(
                internalStateService.getActionByName("component.setUiState")(widgetId, stepId, {
                    actionInProgress: false,
                    isLoading: false
                })
            );
        }
        return actionResult;
    };
}

export function realodFlowOnProcessStep(widgetId, stepId) {
    return (dispatch, getState) => {
        var state = getState();
        var stepData;
        var hasErrors = false;

        stepData = getStepData(state, widgetId, stepId);
        hasErrors = hasStepErrors(stepData);

        if (hasErrors) {
            WEBUILogs.log("Errors found. Skipping flow reload.");

            //scrolling to top to display the errors
            internalStateService.getActionByName("scroll.scrollToTop")();
            return Promise.reject();
        }
        return dispatch(reloadFlow(widgetId));
    };
}

export function getStepData(state, widgetId, stepId) {
    var stepIndex;
    var steps = state.getIn(["data", widgetId, "entities"]);

    if (steps) {
        stepIndex = steps.findIndex((step) => {
            return step.getIn(["step"]) === stepId;
        });

        if (stepIndex !== -1) {
            return state.getIn(["data", widgetId, "entities", stepIndex]);
        }
    }

    return false;
}

export function hasStepErrors(stepData = {}) {
    let stepEntities = stepData.get("entities");
    let errors;
    let hasErrors = false;
    if (stepEntities) {
        errors = stepEntities.find((stepEntity) => {
            if (stepEntity.get("class") && stepEntity.get("class").includes("errors")) {
                return (
                    stepEntity.get("entities") &&
                    stepEntity.get("entities").find((messageEntity) => {
                        return (
                            messageEntity.get("properties") &&
                            (messageEntity.getIn(["properties", "type"]) === "error" ||
                                messageEntity.getIn(["properties", "groupType"]) === "error")
                        );
                    })
                );
            } else return false;
        });
        if (errors) {
            hasErrors = true;
        } else {
            errors = stepEntities.find((stepEntity) => {
                return hasStepErrors(stepEntity);
            });
            hasErrors = errors !== undefined;
        }
    }
    return hasErrors;
}

// function findErrors(stepData = {}) {
//     let stepEntities = stepData.get("entities");
//     let errors;
//     if (stepEntities) {
//         errors = stepEntities.find(stepEntity => {
//             if (stepEntity.get("class") && stepEntity.get("class").includes("errors")) {
//                 return stepEntity.get("entities").find(messageEntity => {
//                     return messageEntity.get("properties") && messageEntity.get("properties").get("type") === "error";
//                 })
//             } else return false
//         });
//         if (!errors) {
//             stepEntities.find(stepEntity => {
//                 errors = findErrors(stepEntity)
//                 return errors
//             })
//         }
//     }
//     return errors;
//
// }

export function postStep(endpoint, widgetId, stepId, sirenAction) {
    WEBUILogs.log("postStep");
    return (dispatch, getState) => {
        var payload = {};
        var flow = getState().getIn(["data", widgetId]).toJS();
        if (isStepLoading(getState(), widgetId, stepId)) {
            return Promise.reject("Action in step not completed - step is loading.");
        }
        if (flow.entities) {
            var stepContent = flow.entities.find((step) => step.step === stepId);
            if (!stepContent) stepContent = {};

            if (stepContent) {
                payload = createFormData(stepContent, sirenAction, undefined, widgetId);
            }
        }
        return dispatch(requestSubmitStep(endpoint, "POST", widgetId, stepId, payload));
    };
}

export function resumeStep(action, widgetId, bindTo) {
    return (dispatch, getState) => {
        var endpoint = action.href;
        if (endpoint) {
            return dispatch(
                requestResumeStep(endpoint, "POST", widgetId, { action: "resumeStep" })
            );
        }
    };
}

function requestResumeStep(endpoint, method, widgetId, payload) {
    return async (dispatch) => {
        let actionResult;
        try {
            await dispatch({
                type: RESUME_STEP_REQUEST
            });
            actionResult = await dispatch(
                internalStateService.getActionByName("request.request")(
                    {
                        endpoint: endpoint,
                        method: method,
                        headers: {
                            "Content-Type": "application/json"
                        },
                        payload: payload
                    },
                    {
                        widgetId: widgetId
                    }
                )
            );
            dispatch({
                type: RESUME_STEP_SUCCESS,
                payload: Object.assign({}, payload, actionResult, { widget: widgetId })
            });
            dispatch((dispatch, getState) => {
                var state = getState();
                var href = null;
                var actions = state.getIn(["data", widgetId, "actions"]);
                var action = null;
                if (actions) {
                    action = actions.find((item, key, iterable) => {
                        return item.get("actionType") === "getAvailableSteps";
                    });
                    href = action && action.get ? action.get("href") : undefined;
                }
                if (href) {
                    return dispatch(loadFlow.apply(undefined, [href, widgetId]));
                } else {
                    WEBUILogs.warn("No siren action for getAvailableSteps!");
                }
            });
        } catch (error) {
            actionResult = Promise.reject(error);
            dispatch({
                type: RESUME_STEP_FAILURE
            });
        }
        return actionResult;
    };
}

export function cancelFlowFromSirenAction(sirenAction = {}, widgetId) {
    return async (dispatch, getState) => {
        var payload = {};
        var endpoint = sirenAction.href;
        var fields = sirenAction["fields"] || [];
        let title = translationService.translate("dialogTitleAttention");
        let message = translationService.translate("flowCancelFlowMessage");
        //Modal type, "info" or "confirm" (having "OK" button only or "OK" and "Cancel")
        let type = "info";
        fields.forEach((field) => {
            payload[field.name] = field.value;
            //Modal Title
            if (field.name === "messageTitle") {
                title = field.value;
            }
            //message content
            if (field.name === "message") {
                message = field.value;
            }
            //message type, one of  [error, success, info, warnring, neutral]
            if (field.name === "type") {
                type = field.value;
            }
        });

        // await dispatch(
        //     internalStateService.getActionByName("messages.openConfirmMessage")({
        //         title,
        //         messages: [message],
        //         type
        //     })
        // );
        await dispatch(
            internalStateService.getActionByName("messages.triggerConfirmMessage")({
                type,
                message,
                title
            })
        );
        return dispatch(requestCancelFlow(endpoint, widgetId, payload));
    };
}

export function cancelFlow(endpoint, widgetId, shouldSwitchDashboard) {
    return (dispatch, getState) => {
        var payload = {};
        try {
            let actions = getState().getIn(["data", widgetId, "actions"]);
            if (actions) {
                let cancelFlowAction = actions.find((item) => {
                    return item.get("actionType") === "cancelFlow";
                });
                if (cancelFlowAction) {
                    let fields = cancelFlowAction.get("fields") || [];
                    fields.forEach((field) => {
                        payload[field.get("name")] = field.get("value");
                    });

                    endpoint = endpoint || cancelFlowAction.get("href");
                }
            }
        } catch (e) {
            WEBUILogs.error(`cancelFlow payload failed to build due to: ${e.message}`);
        }

        return dispatch(requestCancelFlow(endpoint, widgetId, payload, shouldSwitchDashboard));
    };
}

export function requestCancelFlow(endpoint, widgetId, payload, shouldSwitchDashboard = true) {
    if (!endpoint) {
        WEBUILogs.error("Missing enpoint for cancelFlow action.");
        //endpoint defaulted to avoid error thrown from action validator
        endpoint = "defaultEndpoint";
    }

    return async (dispatch) => {
        let actionResult;
        try {
            await dispatch({
                type: CANCEL_FLOW_REQUEST
            });
            actionResult = await dispatch(
                internalStateService.getActionByName("request.request")(
                    {
                        endpoint: endpoint,
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json"
                        },
                        payload: payload
                    },
                    {
                        widgetId: widgetId
                    }
                )
            );
            dispatch({
                type: CANCEL_FLOW_SUCCESS,
                payload: Object.assign({}, payload, actionResult, { widget: widgetId })
            });
            dispatch((dispatch, getState) => {
                var flowStatus;

                if (!shouldSwitchDashboard) {
                    return;
                }

                flowStatus = getState().getIn([widgetId, "status"]);
                if (flowStatus !== "error") {
                    return dispatch(
                        internalStateService.getActionByName("flow.endFlowAndSwitchDashboard")(
                            widgetId
                        )
                    );
                } else {
                    let errors = getState().getIn([widgetId, "errors"]);
                    return dispatch(
                        internalStateService.getActionByName("messages.triggerMessages")([
                            {
                                type: "error",
                                name: translationService.translate("cancelFlowFailure"),
                                messages: [errors]
                            }
                        ])
                    );
                }
            });
        } catch (error) {
            actionResult = Promise.reject(error);
            if (error.name === "ApiError") {
                dispatch(
                    internalStateService.getActionByName("messages.triggerMessages")([
                        {
                            type: "error",
                            messages: [translationService.translate("cancelFlowFailure")]
                        }
                    ])
                );
            }
        }
        return actionResult;
    };
}

export function completeFlow(endpoint, widgetId) {
    return (dispatch, getState) => {
        var payload = {};
        try {
            var actions = getState().getIn(["data", widgetId, "actions"]);
            if (actions) {
                var completeFlowAction = actions.find((item) => {
                    return item.get("actionType") === "completeFlow";
                });
                if (completeFlowAction) {
                    var fields = completeFlowAction.get("fields") || [];
                    fields.forEach((field) => {
                        payload[field.get("name")] = field.get("value");
                    });
                }
            }
        } catch (e) {
            WEBUILogs.error(`completeFlow payload failed to build due to: ${e.message}`);
        }

        return dispatch(requestCompleteFlow(endpoint, widgetId, payload));
    };
}

export function requestCompleteFlow(endpoint, widgetId, payload) {
    return async (dispatch) => {
        let actionResult;
        try {
            await dispatch({
                type: COMPLETE_FLOW_REQUEST
            });
            actionResult = await dispatch(
                internalStateService.getActionByName("request.request")(
                    {
                        endpoint: endpoint,
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json"
                        },
                        payload: payload
                    },
                    {
                        widgetId: widgetId
                    }
                )
            );
            dispatch({
                type: COMPLETE_FLOW_SUCCESS,
                payload: Object.assign({}, payload, actionResult, { widget: widgetId })
            });
            dispatch((dispatch, getState) => {
                let flowStatus = getState().getIn(["data", widgetId, "status"]);
                let flowMessages = getState().getIn(["data", widgetId, "messages"]);

                //in case the user has been notified already
                //and navigation made
                //each step requests completeFlow
                if (flowStatus === "closed") {
                    return;
                }

                if (flowMessages && flowMessages.isEmpty && !flowMessages.isEmpty()) {
                    flowMessages = flowMessages.toJS ? flowMessages.toJS() : flowMessages;
                    let title = translationService.translate("dialogTitleInformation");
                    let content = flowMessages.map((message) => {
                        let text = message.get
                            ? message.getIn(["properties", "value"])
                            : message.properties && message.properties.value
                            ? message.properties.value
                            : "";
                        return text;
                    });
                    return dispatch(
                        internalStateService.getActionByName("messages.triggerMessages")(
                            [
                                {
                                    type: "info",
                                    name: title,
                                    messages: content
                                }
                            ],
                            {
                                acceptLabel: translationService.translate("ok"),
                                acceptActions: [
                                    {
                                        cb: () => {
                                            WEBUILogs.log(
                                                "Complete flow invoked action chain for OK..."
                                            );
                                            if (flowStatus !== "error") {
                                                return dispatch(
                                                    internalStateService.getActionByName(
                                                        "flow.endFlowAndSwitchDashboard"
                                                    )(widgetId)
                                                );
                                            } else {
                                                let errors = getState().getIn([
                                                    "data",
                                                    widgetId,
                                                    "errors"
                                                ]);
                                                return dispatch(
                                                    internalStateService.getActionByName(
                                                        "messages.triggerMessages"
                                                    )([
                                                        {
                                                            type: "error",
                                                            name: translationService.translate(
                                                                "completeFlowFailure"
                                                            ),
                                                            messages: errors
                                                        }
                                                    ])
                                                );
                                            }
                                        }
                                    }
                                ]
                            }
                        )
                    );
                } else {
                    if (flowStatus !== "error" && flowStatus !== "pending") {
                        return dispatch(
                            internalStateService.getActionByName("flow.endFlowAndSwitchDashboard")(
                                widgetId
                            )
                        );
                    } else {
                        let errors = getState().getIn(["data", widgetId, "errors"]);
                        return dispatch(
                            internalStateService.getActionByName("messages.triggerMessages")([
                                {
                                    type: "error",
                                    name: translationService.translate("completeFlowFailure"),
                                    messages: errors
                                }
                            ])
                        );
                    }
                }
            });
        } catch (error) {
            actionResult = Promise.reject(error);
            if (error.name === "ApiError") {
                dispatch(
                    internalStateService.getActionByName("messages.triggerMessages")([
                        {
                            type: "error",
                            messages: [translationService.translate("completeFlowFailure")]
                        }
                    ])
                );
            }
        }
        return actionResult;
    };
}

export function updateStepFromSirenAction(sirenAction, widgetId, path) {
    var endpoint = sirenAction.href;
    var stepId = Array.isArray(path) ? path[1] : path.split(".")[1];
    return (dispatch, getState) => {
        //check if step is loading
        if (isStepLoading(getState(), widgetId, stepId)) {
            return Promise.reject("Action on step incomplete - step is loading.");
        }

        return dispatch(
            putStep(
                endpoint,
                widgetId,
                stepId,
                {
                    actionType: sirenAction.actionType,
                    options: {}
                },
                sirenAction
            )
        );
    };
}

export function putStep(endpoint, widgetId, stepId, options, sirenAction) {
    WEBUILogs.log("putStep");
    return (dispatch, getState) => {
        var payload = {};
        var flow = getState().getIn(["data", widgetId]).toJS();
        if (flow.entities) {
            var stepContent = flow.entities.find((step) => step.step === stepId);
            if (!stepContent) stepContent = {};
            if (stepContent) {
                payload = createFormData(
                    Object.assign({}, stepContent, options),
                    sirenAction,
                    undefined,
                    widgetId
                );
            }
            if (!endpoint) {
                var action = stepContent.actions.find((action) => {
                    return action.actionType === "processStep";
                });
                if (action && action.href) endpoint = action.href;
            }
        }
        return dispatch(requestSubmitStep(endpoint, "PUT", widgetId, stepId, payload));
    };
}

export function triggerStepAddCollectionItem(widgetId, path, options) {
    var endpoint = null;
    var stepId = path.split(".")[1];
    return (dispatch, getState) => {
        return dispatch(
            putStep(endpoint, widgetId, stepId, { actionType: "addElement", options: options })
        );
    };
}

export function triggerStepRemoveCollectionItem(widgetId, path, pathInStore, options) {
    var endpoint = null;
    var stepId = path.split(".")[1];
    return (dispatch, getState) => {
        dispatch(
            stepDeleteCollectionItemFromStore(widgetId, stepId, pathInStore, {
                actionType: "removeElement",
                options: options
            })
        );
        return dispatch(
            putStep(endpoint, widgetId, stepId, { actionType: "removeElement", options: options })
        );
    };
}

export function stepDeleteCollectionItemFromStore(widgetId, step, path, options) {
    var newPath = path;
    if (newPath.pop() === "properties") {
        path = newPath;
    }
    path.pop();
    return {
        type: "STEP_REMOVE_COLLECTION_ITEM_FROM_STORE",
        payload: {
            widget: widgetId,
            step: step,
            path: path,
            options: options
        }
    };
}

function createFlow(endpoint, widget, payload, options = {}) {
    return async (dispatch) => {
        let actionResult;
        // let flowTarget =
        //     payload.action && payload.action.parameters && payload.action.parameters.flowTarget;
        try {
            await dispatch({
                type: REQUEST_FLOW_REQUEST
            });
            actionResult = await dispatch(
                internalStateService.getActionByName("request.request")(
                    {
                        endpoint: endpoint,
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json"
                        },
                        payload: payload
                    },
                    {
                        widgetId: widget
                    }
                )
            );
            dispatch({
                type: WIDGET_DATA_SUCCESS,
                payload: Object.assign({}, payload, actionResult, { widget: widget })
            });
            dispatch({
                type: SET_ACTIVE_FLOW,
                payload: {
                    widget: widget,
                    isBlocking: options.isBlocking,
                    saveFlowBeforeExit: options.saveFlowBeforeExit
                }
            });
            // dispatch({
            //     type: SET_ACTIVE_FLOW_TARGET,
            //     payload: {
            //         activeFlowTarget: flowTarget
            //     }
            // });
            dispatch((dispatch, getState) => {
                let state = getState();
                let href = null;
                let actions = state.getIn(["data", widget, "actions"]);
                let action = null;
                if (actions) {
                    action = actions.find((item, key, iterable) => {
                        return item.get("actionType") === "getAvailableSteps";
                    });
                    href = action.get("href");
                }
                if (href) {
                    return dispatch(loadFlow.apply(undefined, [href, widget]));
                }
            });
        } catch (error) {
            actionResult = Promise.reject(error);
            if (error.name === "ApiError") {
                dispatch(
                    internalStateService.getActionByName("messages.triggerMessages")([
                        {
                            type: "error",
                            messages: [translationService.translate("requestFlowFailure")]
                        }
                    ])
                );
            }
        } finally {
            dispatch(
                setFlowUiState(widget, {
                    flowLoading: false
                })
            );
        }
        return actionResult;
    };
}
export function requestFlow(sirenAction, widget) {
    return (dispatch) => {
        let payload = createJSONData(widget, sirenAction);
        return dispatch(requestFlowAction(sirenAction.href, widget, payload));
    };
}
export function requestFlowAction(endpoint, widget, payload = {}, options = {}) {
    // const updateLocationStateDashboard = internalStateService.getActionByName(
    //     "routing.updateLocationStateDashboard"
    // );
    WEBUILogs.log("requestFlow");
    return async (dispatch, getState) => {
        if (endpoint) {
            dispatch(
                setFlowUiState(widget, {
                    flowLoading: true
                })
            );
            if (internalStateService.getGlobalProperties("screenSizeQueryParameter")) {
                let screenSize = getState().getIn(["windowSize", "size"]);
                //screenSize=${size}
                endpoint = urlUtils.updateUrlParameters(endpoint, { screenSize });
            }
            let createFlowResponse = await dispatch(createFlow(endpoint, widget, payload, options));
            //let flowId = createFlowResponse.properties ? createFlowResponse.properties.id : "";
            //dispatch(updateLocationStateFlowData(flowId));
            // if (internalStateService.getGlobalProperties("dashboardPathname") === "queryParams") {
            //     dispatch(updateLocationStateDashboard({ flow: flowId }));
            // }
            return createFlowResponse;
        }
    };
}

// function updateLocationStateFlowData(flowId) {
//     const getCurrentLocationState = internalStateService.getActionByName(
//         "routing.getCurrentLocationState"
//     );
//     return (dispatch, getState) => {
//         let currentLocationState = dispatch(getCurrentLocationState());
//         let previousRoute;
//         let savedRoutes = getState().getIn(["routes", "routes"]);
//         if (savedRoutes && savedRoutes.size > 1) {
//             previousRoute = savedRoutes.get(savedRoutes.size - 2);
//         }
//         //will update only if no flowData is set on the current location
//         if (previousRoute && !currentLocationState.flowData) {
//             return dispatch(
//                 internalStateService.getActionByName("routing.updateLocationState")({
//                     flowData: {
//                         id: flowId,
//                         completeFlowNextRoute: previousRoute
//                     }
//                 })
//             );
//         }
//     };
// }

export function endFlow(widget, flow) {
    WEBUILogs.log("END_FLOW dispatched...");
    return {
        type: END_FLOW,
        payload: {
            widget: widget,
            flow: flow
        }
    };
}

export function endFlowAndSwitchDashboard(widget) {
    return (dispatch) => {
        // Unset global property.
        dispatch(triggerResetActiveFlow());
        dispatch(endFlow(widget));
        return dispatch(redirectOnFlowCompleted());
    };
}

//switches to previous route if available
//can be overridden
export function redirectOnFlowCompleted() {
    const getCurrentLocationState = internalStateService.getActionByName(
        "routing.getCurrentLocationState"
    );
    return (dispatch) => {
        let currentLocationState = dispatch(getCurrentLocationState());
        let flowStateData = currentLocationState.flowData || {};
        let nextRoute = flowStateData.completeFlowNextRoute;
        if (!nextRoute) {
            let defaultRoute = internalStateService.getWebConfig()["ROOT_PATH"];
            WEBUILogs.error("Missing previous route, redirecting to " + defaultRoute);
            nextRoute = defaultRoute;
        }
        return dispatch(internalStateService.getActionByName("dashboard.switchToRoute")(nextRoute));
    };
}

export function triggerResetActiveFlow() {
    return {
        type: RESET_ACTIVE_FLOW
    };
}

export function triggerSetFlowContext(flowContext) {
    return {
        type: SET_FLOW_CONTEXT,
        payload: {
            flowContext: flowContext
        }
    };
}
// export function triggerSetActiveFlowTarget(target) {
//     return {
//         type: SET_ACTIVE_FLOW_TARGET,
//         payload: {
//             activeFlowTarget: target
//         }
//     };
// }
//
// export function triggerResetActiveFlowTarget() {
//     return {
//         type: RESET_ACTIVE_FLOW_TARGET
//     };
// }

function isStepLoading(store, widgetId, stepId) {
    var isLoading;

    isLoading = store.getIn(["uiState", widgetId, stepId, "isLoading"]);

    return isLoading;
}

//sets flow uistate
//limitation:
//flow componentId is the same as the widgetId
//flow<->step dependency
export function setFlowUiState(widgetId, newState) {
    return internalStateService.getActionByName("component.setUiState")(
        widgetId,
        widgetId,
        newState
    );
}
